// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import eventRoomEntity from './entities/event-room.json';
import eventRoomMenu from '../pages/event-room/menu.json';
import eventRoomFullForm from '../pages/event-room/forms/full.json';
import eventRoomContextForm from '../pages/event-room/forms/context.json';
import eventRoomMiniForm from '../pages/event-room/forms/mini.json';
import eventRoomLookupForm from '../pages/event-room/forms/lookup.json';
import eventRoomTableView from '../pages/event-room/views/table.json';
import eventRoomCardsView from '../pages/event-room/views/cards.json';
import eventRoomDashboardView from '../pages/event-room/views/dashboard.json';

/** Тип запису «Приміщення» зі сторінками пакета: меню, форми та подання з pages/event-room/. */
export const eventRoomDefinition: IRecordTypeDefinition = {
  ...eventRoomEntity,
  views: assembleViewSet({
      table: eventRoomTableView,
      cards: eventRoomCardsView,
      dashboard: eventRoomDashboardView,
  }),
  form: eventRoomFullForm,
  forms: { full: eventRoomFullForm, context: eventRoomContextForm, mini: eventRoomMiniForm, lookup: eventRoomLookupForm },
  menu: eventRoomMenu,
} as IRecordTypeDefinition;
